import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";

export function useMachineMetrics(machineId: number, range: string) {
  return useQuery({
    queryKey: ["machine-metrics", machineId, range],
    queryFn: () => api.getMachineMetrics(machineId, range),
    enabled: machineId > 0,
    refetchInterval: 30_000,
  });
}
